import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

import { DaysPassedPipeModule } from '@shared/pipes';

import { AttachmentsListComponent } from './attachments-list.component';

@NgModule({
  declarations: [AttachmentsListComponent],
  imports: [DaysPassedPipeModule, CommonModule, MatCardModule, MatIconModule, MatMenuModule],
  exports: [AttachmentsListComponent],
})
export class AttachmentsListModule {}
